import React from 'react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { Button, Form, Header, Segment, Input } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class NewGroup extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            staff: [],
            name: '',
            groupType: this.props.location.state.groupType,
            staffIds: [],

            nameErr: false,
            groupTypeErr: false,
            staffIdsErr: false,
            addedGroup: null,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.createGroup = this.createGroup.bind(this);
    }

    componentDidMount() {
        axios.get(`course/implementation/staff/${localStorage.getItem('courseImplementation')}`)
            .then(res => {
                const staff = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.employee.person.firstName + ' ' + el.employee.person.lastName + ' (' + el.courseRoleType.name + ')'
                }));
                this.setState({ staff });
            })
            .catch(err => {
                console.log('Failed to fetch staff');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    createGroup() {
        const { name, staffIds } = this.state;

        if (!name || staffIds.length === 0) {
            toast('Niste unijeli sva obavezna polja!');
            if (!name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (staffIds.length === 0) { this.setState({ staffIdsErr: true }); } else { this.setState({ staffIdsErr: false }); }
        } else {
            // let groupTypes = groupType.map(el => ({ id: el }));
            let groupTypes = [{ id: localStorage.getItem('groupType') }];

            const newGroup = {
                name,
                courseImplementation: { id: localStorage.getItem('courseImplementation') },
                groupTypes
            };

            axios.post('course/groups/add', { ...newGroup })
                .then(res => {
                    let staffGroup = staffIds.map(el => ({
                        courseImplementationStaff: { id: el },
                        courseImplementationGroup: { id: res.data.id }
                    }));

                    axios.post('course/groups/add-staff', [...staffGroup])
                        .then(ress => {
                            this.setState({ addedGroup: true });
                        })
                        .catch(e => {
                            this.setState({ addedGroup: false });
                        });
                })
                .catch(err => {
                    toast('Došlo je do greške! Studentska grupa nije kreirana.');
                });
        }
    }


    render() {
        const { addedGroup } = this.state;
        if (addedGroup === true) {
            return (<Redirect
                push
                to={{
                    pathname: this.props.location.pathname === '/ispitne-grupe/nova-grupa' ? '/ispitne-grupe' : '/studentske-grupe',
                    state: {
                        addedGroup: true
                    }
                }}
            />);
        } else if (addedGroup === false) {
            return (<Redirect
                push
                to={{
                    pathname: this.props.location.pathname === '/ispitne-grupe/nova-grupa' ? '/ispitne-grupe' : '/studentske-grupe',
                    state: {
                        addedGroup: false
                    }
                }}
            />);
        }

        return (
            <div>
                <Header as="h1"> {this.props.location.pathname === '/ispitne-grupe/nova-grupa' ? 'Kreiranje ispitne grupe' : 'Kreiranje grupe za predavanja'}</Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            {this.props.location.state.courseImplName}
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    control={Input}
                                    label="Naziv grupe"
                                    value={this.state.name}
                                    onChange={(e) => this.setState({ name: e.target.value })}
                                    name="name"
                                    placeholder="Unesite naziv grupe"
                                    error={this.state.nameErr}
                                />
                                {/* <Form.Field> */}
                                {/* <Form.Dropdown clearable */}
                                {/* placeholder="Odaberite tip grupe" */}
                                {/* value={this.state.groupType} */}
                                {/* defaultValue={this.props.location.state.groupType} */}
                                {/* onChange={this.handleInputChange} */}
                                {/* name="groupType" */}
                                {/* options={this.state.groupTypes} */}
                                {/* label="Tip grupe" */}
                                {/* search */}
                                {/* fluid */}
                                {/* selection */}
                                {/* required */}
                                {/* error={this.state.groupTypeErr} */}
                                {/* /> */}
                                {/* </Form.Field> */}

                                <Form.Field required error={this.state.staffIdsErr}>
                                    <Form.Dropdown
                                        required
                                        clearable
                                        placeholder="Odaberite nastavno osoblje"
                                        value={this.state.staffIds}
                                        onChange={this.handleInputChange}
                                        name="staffIds"
                                        options={this.state.staff}
                                        label="Nastavno osoblje"
                                        search
                                        fluid
                                        selection
                                        multiple
                                    />
                                </Form.Field>
                            </Form.Group>
                            <br />
                            <Button color="blue" floated="right" basic="true" onClick={() => window.history.go(-1)}>Odustani</Button>
                            <Button color="blue" floated="right" onClick={this.createGroup}>Kreiraj</Button>
                        </Form>
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/NewGroup.js